import Network from '@/services/network'
import {ref} from 'vue'

export default function handleMoneyReceipt() {
	const network = new Network;
	const loading = ref(false)
	
	const fetchMoneyReceiptList = (query) => {
		return network.api('get', '/money-receipt' + query);
	}

	const fetchMoneyReceipts = (query) => {
		return network.api('get', '/money-receipt/list' + query);
	}

	const fetchPharmacyMoneyReceiptList = (query) => {
		return network.api('get', '/money-receipt/pharmacy-list' + query);
	}

	return {
		fetchMoneyReceiptList,
		loading,
		fetchMoneyReceipts,
		fetchPharmacyMoneyReceiptList
	}
}